import axios from 'axios';
import { attachTokenToHeaders } from '../auth/actions';
import { UsersActions, UsersActionTypes } from './types';
import { Dispatch } from 'react';
import { RootState } from 'store/reducers';

export const getUsers = () => async (dispatch: Dispatch<UsersActions>, getState: () => RootState) => {
  dispatch({
    type: UsersActionTypes.GET_USERS_LOADING,
  });
  try {
    const options = attachTokenToHeaders(getState);
    const response = await axios.get('/api/users', options);

    dispatch({
      type: UsersActionTypes.GET_USERS_SUCCESS,
      payload: { users: response.data.users  },
    });
  } catch (err: any) {
    dispatch({
      type: UsersActionTypes.GET_USERS_FAIL,
      payload: err.message,
    });
  }
};
